export const NAVIGATION_ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  SIGN_IN: "/signin",
  REGISTER: "/register",
  RESET: "/reset",
  RESET_PASSWORD: "reset/password",
  ONBOARDING: "/onboarding",
  PRICING: "/pricing",
  CALL_HISTORY: "/portal/call-records",
  CALL_LOGS: "/admin/portal",
  SETTING: "/settings",
  PORTAL: "/portal",
  AGENT: "/portal/agents",
  ACCEPT_INVITATION: "/accept-invitation",
  PAYMENT_SUCCESS: "/success",
  BILLINGS: "/billings",
  SUBSCRIPTION: "/settings/subscription",
  DIALER: "/dialer",
  DIALER_MESSAGES: "/dialer/messages",
  DIALER_MESSAGES_NEW: "/dialer/messages/new",
  DIALER_MESSAGES_SEARCH: "/dialer/messages/search",
  DIALER_CONTACTS: "/dialer/contacts",
  DIALER_CALL_LOGS: "/dialer/calllogs",
  DIALER_CALL_LOGS_SEARCH: "/dialer/calllogs/search",
  DIALER_THREADS: "/dialer/messages/thread",
  INTEGRATIONS: "/integrations",
  LANDING: "/home",
  CREDITS: "/credits",
  GOGGLE_LOGIN: "/auth-signin"
}
